import React, { memo, useEffect, useContext, useState } from "react"
import { randomBytes } from "crypto"
import PropTypes from "prop-types"
import CSlider from "./stencil/cslider-wrapper"

const IndexSlider = ({
  lang = "de",
  dimensions,
  intervalFunc,
  prevLabelFunc,
  nextLabelFunc,
}) => (
  <>
    {/* Making sure the video's poster is rendered at the right size */}
    <style key={randomBytes(6).toString("hex")}>{`
    .video-js{
          width:${dimensions[0]}px;
          height:${dimensions[1]}px;
        }
      `}</style>
    <CSlider
      key={randomBytes(6).toString("hex")}
      sliderClasses="index-slider"
      slides={5}
      stopFirstAndLastSlideTransitions={true}
      intervalExternalFunction={intervalFunc}
      intervalTimeoutDuration={5000}
      prevLabelFunc={prevLabelFunc}
      nextLabelFunc={nextLabelFunc}
      dynamicIntervalTimeoutArray={[[0, 30000]]}
      touchScrollable={true}
      lang={lang}
      path="home"
      radioButtonIdOffset={50}
    >
      <div className="carousel-item">
        <c-video
          index={0}
          account="schneckenhof"
          alias="senses-integration/home/sample_1920x1080_gabetp"
          crop="fill"
          path="home"
          videoLang={lang}
          width={dimensions[0]}
          height={dimensions[1]}
        />
      </div>
      <div className="carousel-item">
        <c-image
          account="schneckenhof"
          alias="senses-integration/home/Senses-Integration-Start06_dtivg7"
          crop="fill"
          width={dimensions[0]}
          height={dimensions[1]}
        />
      </div>
      <div className="carousel-item">
        <c-image
          account="schneckenhof"
          alias="senses-integration/home/Senses-Integration-Start05_iunj5x"
          crop="fill"
          width={dimensions[0]}
          height={dimensions[1]}
        />
      </div>
      <div className="carousel-item">
        <c-video
          index={3}
          path="home"
          videoLang={lang}
          account="schneckenhof"
          alias="senses-integration/home/Senses-Integration-Start04_uhrcr0"
          crop="fill"
          width={dimensions[0]}
          height={dimensions[1]}
        />
      </div>
      <div className="carousel-item">
        <c-image
          account="schneckenhof"
          alias="senses-integration/home/Senses-Integration-Start03_dvzhjo"
          crop="fill"
          width={dimensions[0]}
          height={dimensions[1]}
        />
      </div>
    </CSlider>
  </>
)

IndexSlider.propTypes = {
  lang: PropTypes.string,
  dimensions: PropTypes.array,
  intervalFunc: PropTypes.func,
  prevLabelFunc: PropTypes.func,
  nextLabelFunc: PropTypes.func,
}

export default memo(IndexSlider)
